/**
 * Localization map: raw CLQ field names (often German/abbreviated) → display labels.
 * Used anywhere field names appear in the dashboard UI.
 */
export const FIELD_LABELS: Record<string, string> = {
  // Identifiers
  Time:              'Timestamp',
  SN:                'Serial No.',
  MachineId:         'Machine ID',
  CompanySlug:       'Company',
  SiteSlug:          'Site',
  State:             'State',
  Status:            'Status',

  // Thermal
  KuehlerTemp:       'Cooler Temp (°C)',
  AmbientTemp:       'Ambient Temp (°C)',
  Feuchte:           'Humidity (%)',
  TempResonator:     'Resonator Temp (°C)',
  TempFaser1:        'Fiber Temp 1 (°C)',
  TempFaser2:        'Fiber Temp 2 (°C)',
  Temp1Optik:        'Optics Temp 1 (°C)',
  Temp2Optik:        'Optics Temp 2 (°C)',
  Temp3Optik:        'Optics Temp 3 (°C)',
  Temp4Optik:        'Optics Temp 4 (°C)',

  // Electrical
  Supply_Ia:         'Supply Current (A)',

  // Power / Resonator
  LaserPower_SET:    'Laser Power SET (W)',
  LaserPower_ACT:    'Laser Power ACT (W)',

  // Frequency
  LaserFrequenz:     'Laser Freq (kHz)',
  LaserFrequenz_SET: 'Laser Freq SET (Hz)',
  LaserFrequenz_ACT: 'Laser Freq ACT (Hz)',

  // Duty cycle
  DutyCycle_SET:     'Duty Cycle SET (%)',
  DutyCycle_ACT:     'Duty Cycle ACT (%)',

  // Optics
  BeamAlignment:     'Beam Alignment',

  // Chiller
  Chi_Drehzahl:      'Chiller RPM',
  Chi_Kaelteleistung:'Chiller Output (kW)',
  Chi_Ruecklauftemp: 'Chiller Return Temp (°C)',
  Chi_Tanktemp:      'Chiller Tank Temp (°C)',
  Chi_ExtWasserTemp: 'Chiller Ext Water Temp (°C)',
  Chi_Durchf_Main:   'Chiller Flow Main (L/min)',
  Chi_Durchf_Optik:  'Chiller Flow Optics (L/min)',
  Chi_Durchf_Help:   'Chiller Flow Aux (L/min)',
  Chi_Hochdruck:     'Chiller High Pressure (bar)',
  Chi_Wasserdruck:   'Chiller Water Pressure (bar)',
  Chi_Leistung:      'Chiller Power (kW)',
  Chi_Betriebsart:   'Chiller Mode',

  // Counters
  HoursRunning:      'Hours Running',
  Cycles:            'Cycles',

  // ZEIT (time-in-state counters, seconds)
  ZEIT_IDLE:      'Time Idle (s)',
  ZEIT_READY:     'Time Ready (s)',
  ZEIT_RUNNING:   'Time Running (s)',
  ZEIT_ERROR:     'Time Error (s)',
  ZEIT_STATE_OFF: 'Time Off (s)',
};

/** Return the English display label for a field, or a prettified version of the key. */
export function fieldLabel(key: string): string {
  if (FIELD_LABELS[key]) return FIELD_LABELS[key];
  // Fallback: replace underscores with spaces, title-case
  return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
